import { Link } from "react-router-dom"
import { Home } from "lucide-react"
import { Separator } from "@/components/ui/separator"
import { SidebarTrigger } from "@/components/ui/sidebar"
import {
  Breadcrumb,
  BreadcrumbList,
  BreadcrumbItem,
  BreadcrumbLink,
  BreadcrumbPage,
  BreadcrumbSeparator,
} from "@/components/ui/breadcrumb"
import { useBreadcrumb } from "@/contexts/BreadcrumbContext"

export function SiteHeader() {
  const { breadcrumbs } = useBreadcrumb()
  
  // Flatten items with separators for rendering
  const breadcrumbElements = breadcrumbs.flatMap((item, index) => [
    ...(index > 0 ? [{ type: "separator" as const, key: `sep-${index}` }] : []),
    { type: "item" as const, ...item, isLast: index === breadcrumbs.length - 1, key: `item-${index}` },
  ])

  return (
    <header className="flex h-(--header-height) shrink-0 items-center gap-2 border-b transition-[width,height] ease-linear group-has-data-[collapsible=icon]/sidebar-wrapper:h-(--header-height)">
      <div className="flex w-full items-center gap-1 px-4 lg:gap-2 lg:px-6">
        <SidebarTrigger className="-ml-1" />
        <Separator
          orientation="vertical"
          className="mx-2 data-[orientation=vertical]:h-4"
        />
        <div className="min-w-0 flex-1 overflow-x-auto overscroll-x-contain">
        <Breadcrumb>
          <BreadcrumbList>
            <BreadcrumbItem>
              <BreadcrumbLink asChild>
                <Link to="/">
                  <Home className="size-4" />
                </Link>
              </BreadcrumbLink>
            </BreadcrumbItem>
            {breadcrumbs.length > 0 && <BreadcrumbSeparator />}
            {breadcrumbElements.map((element) =>
              element.type === "separator" ? (
                <BreadcrumbSeparator key={element.key} />
              ) : (
                <BreadcrumbItem key={element.key}>
                  {element.isLast ? (
                    <BreadcrumbPage>{element.label}</BreadcrumbPage>
                  ) : (
                    <BreadcrumbLink asChild>
                      <Link to={element.path}>{element.label}</Link>
                    </BreadcrumbLink>
                  )}
                </BreadcrumbItem>
              )
            )}
          </BreadcrumbList>
        </Breadcrumb>
        </div>
      </div>
    </header>
  )
}
